import { registerHandle, resolve, summarizeRef, SourceSchema } from '@/agent/refs';
import type { Tool } from './types';

type Input = { text: string; max_results?: number };

export const resolvePlace: Tool<Input> = {
  name: 'resolve_place',
  description:
    'Geocode a free-text place name via the AGOL World Geocoding Service. Returns candidates plus a handle to the top match. No map side-effects — pair with view.zoom_to or render to actually show it.',
  input_schema: {
    type: 'object',
    properties: {
      text: { type: 'string' },
      max_results: { type: 'integer', minimum: 1, maximum: 10 },
    },
    required: ['text'],
    additionalProperties: false,
  },
  execute: async ({ text, max_results }) => {
    const ref = await resolve({ kind: 'place', text, max_results });
    const handle = registerHandle(ref);
    return {
      handle,
      summary: summarizeRef(ref),
      candidates: (ref.candidates ?? []).map((c) => ({
        address: c.address,
        score: c.score,
        x: c.geometry.x,
        y: c.geometry.y,
        wkid: c.geometry.spatialReference?.wkid ?? undefined,
      })),
    };
  },
};

void SourceSchema;
